/**
 * The account domain's browser face (ADR 0014).
 *
 * The browser Supabase client, the four auth forms, the API-key surface and the sign-out button.
 *
 * **No module here may import `@/account/server`** (ADR 0010, R7). That is not a style rule: a face
 * a client component imports fails `pnpm build` the moment it reaches `server/supabase.ts`, on
 * `next/headers`, and the failure is reproducible on demand.
 *
 * **Why this is a third face rather than part of the isomorphic one.** The build does not force it —
 * a two-face `account/` with a live `'use client'` component on the isomorphic face builds green,
 * measured on #363. The *name* forces it: `client/supabase.ts` and `server/supabase.ts` both export
 * `createClient`, one async and one not, ADR 0009:74-76 forecloses unifying the signatures, and
 * ADR 0014:82 forbids a name appearing twice on a published surface. Two surfaces is what lets both
 * keep the name they have. `social/` has no such repeat and takes two faces at step 7 (#364) — same
 * rule, different answer.
 *
 * **Explicit named exports, never `export *`** (ADR 0014:81-82).
 */

export { createClient } from './supabase'
export { LoginForm } from './login-form'
export { SignUpForm } from './sign-up-form'
export { ForgotPasswordForm } from './forgot-password-form'
export { UpdatePasswordForm } from './update-password-form'
export { ApiKeysView } from './api-keys-view'
export { SignOutButton } from './sign-out-button'
